import { Link } from 'react-router-dom';

export default function ServiceAreasSection() {
  const areas = [
    { name: 'Allentown, PA', icon: 'ri-map-pin-fill' },
    { name: 'Bethlehem, PA', icon: 'ri-map-pin-fill' },
    { name: 'Easton, PA', icon: 'ri-map-pin-fill' },
    { name: 'Nazareth, PA', icon: 'ri-map-pin-fill' },
    { name: 'Forks Township, PA', icon: 'ri-map-pin-fill' },
    { name: 'Wind Gap, PA', icon: 'ri-map-pin-fill' },
    { name: 'Pen Argyl, PA', icon: 'ri-map-pin-fill' },
    { name: 'Bangor, PA', icon: 'ri-map-pin-fill' },
    { name: 'Bath, PA', icon: 'ri-map-pin-fill' },
    { name: 'Whitehall, PA', icon: 'ri-map-pin-fill' },
    { name: 'Northampton, PA', icon: 'ri-map-pin-fill' },
    { name: 'Hellertown, PA', icon: 'ri-map-pin-fill' },
    { name: 'Phillipsburg, NJ', icon: 'ri-map-pin-fill' },
    { name: 'Tatamy, PA', icon: 'ri-map-pin-fill' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            Areas We Serve in the Lehigh Valley
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proudly serving Allentown, Bethlehem, Easton, and surrounding Pennsylvania and New Jersey communities with premier event entertainment rentals.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
          {areas.map((area, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all"
            >
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                  <i className={`${area.icon} text-xl text-red-600`}></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">{area.name}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">Don't See Your Area Listed?</h3>
          <p className="text-base mb-6 max-w-2xl mx-auto">
            We may still be able to serve you! Contact us to discuss your event location and we'll do our best to accommodate your needs.
          </p>
          <Link 
            to="/service-areas" 
            className="inline-block bg-white text-red-600 px-8 py-4 rounded-full text-base font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
          >
            View Full Service Area Map
          </Link>
        </div>
      </div>
    </section>
  );
}